// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.indicator-carousel-placeholder {
  min-height: 360px;
}

.level-transition {
  margin-top: 18px;
}

@media (max-width: 480px) {
  .indicator-carousel-placeholder {
    min-height: 260px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/charts/IndicatorTabs/IndicatorCarousel.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".indicator-carousel-placeholder {\n  min-height: 360px;\n}\n\n.level-transition {\n  margin-top: 18px;\n}\n\n@media (max-width: 480px) {\n  .indicator-carousel-placeholder {\n    min-height: 260px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
